import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';  

// Import default translation files
import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import cn from './locales/cn/translation.json';
import de from './locales/de/translation.json';
import es from './locales/es/translation.json';
import hi from './locales/hi/translation.json';
import sa from './locales/sa/translation.json';
import ka from './locales/ka/translation.json';

// Function to load user-defined translations from localStorage
const loadUserDefinedTranslations = () => {
  try {
    const storedTranslations = localStorage.getItem('translations_ud');
    return storedTranslations ? JSON.parse(storedTranslations) : {};
  } catch (error) {
    // console.error('Failed to load user-defined translations:', error);
    return {};
  }
};

// Initial resources with default translations
const initialResources = {
  en: { translation: en },
  fr: { translation: fr },
  zh: { translation: cn },
  de: { translation: de },
  es: { translation: es },
  hi: { translation: hi },
  kn: { translation: ka },
  ar: { translation: sa },
  ud: { translation: loadUserDefinedTranslations() }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: initialResources,
    fallbackLng: 'en',
    debug: false,
   
    interpolation: {
      escapeValue: false,
    },
    // Add a custom load handler to update user-defined translations
    load: (languages, callback) => {
      languages.forEach(language => {
        if (language === 'ud') {
          const userDefinedTranslations = loadUserDefinedTranslations();
          
          // Clear existing ud resources
          Object.keys(i18n.store.data.ud || {}).forEach(namespace => {
            delete i18n.store.data.ud[namespace];
          });

          // Add user-defined translations
          Object.entries(userDefinedTranslations).forEach(([namespace, translations]) => {
            i18n.addResourceBundle('ud', namespace, translations, true, true);
          });
        }
      });
      callback(null, languages);
    }
  });

// Add a method to update user-defined translations
i18n.updateUserDefinedTranslations = (newTranslations) => {
  try {
    // Merge with existing translations
    const existingTranslations = loadUserDefinedTranslations();
    const mergedTranslations = {
      ...existingTranslations,
      ...newTranslations
    };

    // Save to localStorage
    localStorage.setItem('translations_ud', JSON.stringify(mergedTranslations));

    // Update i18next resources
    Object.entries(mergedTranslations).forEach(([namespace, translations]) => {
      i18n.addResourceBundle('ud', namespace, translations, true, true);
    });

    // Trigger language change to ud to refresh translations
    if (i18n.language === 'ud') {
      i18n.changeLanguage('ud');
    }
  } catch (error) {
    // console.error('Failed to update user-defined translations:', error);
  }
};

export default i18n;